import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import useQueryString from '../../hooks/use-query-string';

export default function Refocuser() {
  const { pathname } = useLocation()
  const query = useQueryString()

  useEffect(() => window.scrollY > 0 && window.scrollTo(0, 0), [pathname, JSON.stringify((query))])

  return null
}
